import { render, staticRenderFns } from "./hyjy.vue?vue&type=template&id=8b00dbe6"
import script from "./hyjy.vue?vue&type=script&lang=js"
export * from "./hyjy.vue?vue&type=script&lang=js"
import style0 from "./hyjy.vue?vue&type=style&index=0&id=8b00dbe6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports